// FacilitatorPageHeader
// Canonical banner used at the top of every educator-facing page so the
// admin section reads as a single workspace rather than a patchwork.
//
// Layout matches the Inpatient case library reference:
//   - Title + description take the top of the banner.
//   - Page-specific `actions` (Save / Publish / New / Walkthrough, etc.)
//     sit on the right of the title in the same row.
//   - The Back button sits BELOW the title block, full-width row, like
//     the case library. Keeps it predictably in the same place across
//     pages so a lecturer always knows where to look.
//
// Replaces the bespoke title bars that used to live in each library /
// editor and fixes the long-standing invisible Back button bug — the
// old `outline-light` variant rendered white text on the light tinted
// header background.

import React from 'react';
import Button from 'react-bootstrap/Button';

const FacilitatorPageHeader = ({ title, description, onBack, backLabel = 'Back', actions = null }) => (
  <div className="student-dashboard-shell">
    <div className="student-dashboard-header">
      <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
        <div className="flex-grow-1">
          <h2 className="mb-2">{title}</h2>
          {description ? (
            <p className="student-dashboard-header__copy mb-0">{description}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="d-flex gap-2 flex-wrap align-items-start">
            {actions}
          </div>
        ) : null}
      </div>
      {onBack ? (
        <div className="mt-3">
          <Button type="button" variant="outline-secondary" size="sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-1" aria-hidden="true" />
            {backLabel}
          </Button>
        </div>
      ) : null}
    </div>
  </div>
);

export default FacilitatorPageHeader;
